import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { adminApi, extractError } from '../api/client';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = useMemo(() => (params.get('token') || '').trim(), [params]);
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!token) { setError('Reset link is missing or invalid.'); return; }
    if (pwd.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (pwd !== pwd2) { setError('Passwords do not match.'); return; }
    setSubmitting(true);
    try {
      await adminApi.post('/auth/reset-password', { token, new_password: pwd });
      setDone(true);
      setTimeout(() => navigate('/login'), 1800);
    } catch (err) {
      setError(extractError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card" data-testid="reset-password-card">
        <div className="login-brand">
          <span className="brand-mark">NV</span>
          <div>
            <div style={{ fontWeight: 700, fontFamily: 'var(--font-heading)' }}>National Voter Guide</div>
            <div className="text-muted" style={{ fontSize: '0.85rem' }}>Choose a new password</div>
          </div>
        </div>

        {!token && (
          <Alert variant="warning" data-testid="reset-password-missing-token">
            This reset link is missing a token. <Link to="/forgot-password">Request a new one</Link>.
          </Alert>
        )}

        {done ? (
          <Alert variant="success" data-testid="reset-password-success">
            Password updated. Redirecting you to sign in…
          </Alert>
        ) : (
          <>
            {error && <Alert variant="danger" data-testid="reset-password-error">{error}</Alert>}
            <Form onSubmit={handleSubmit} noValidate>
              <Form.Group className="mb-3">
                <Form.Label>New password</Form.Label>
                <Form.Control
                  type="password"
                  autoComplete="new-password"
                  required
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                  data-testid="reset-password-input"
                />
                <Form.Text>Minimum 6 characters.</Form.Text>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Confirm new password</Form.Label>
                <Form.Control
                  type="password"
                  autoComplete="new-password"
                  required
                  value={pwd2}
                  onChange={(e) => setPwd2(e.target.value)}
                  data-testid="reset-password-confirm-input"
                />
              </Form.Group>
              <Button type="submit" variant="primary" className="w-100" disabled={submitting || !token} data-testid="reset-password-submit-button">
                {submitting ? <><Spinner size="sm" animation="border" /> Updating…</> : 'Update password'}
              </Button>
              <div className="mt-3 text-center">
                <Link to="/login" className="text-decoration-none" style={{ fontSize: '0.88rem' }}>&larr; Back to sign in</Link>
              </div>
            </Form>
          </>
        )}
      </div>
    </div>
  );
}
